/**
 * 向上滾動按鈕
 */
function scrollTopHandler() {
  const scrollTopBtn = document.querySelectorAll(`[data-id="scrollTop-btn"]`);
  scrollTopBtn.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  });
}

export default scrollTopHandler;
